import {css} from 'styled-components'

export const placeholderCss = (props) => {
    return css`
        &::-webkit-input-placeholder { /* WebKit, Blink, Edge */
            ${props}
        }
        &:-moz-placeholder { /* Mozilla Firefox 4 to 18 */
            ${props}
        }
    `
}